

import { useEffect, useState } from "react";
import {
  getUsers,
  getUserRoles,
  removeRole,
  getAppUsersWithRoles
} from "../../services/accessControl.api";
import AssignRoleModal from "./AssignRoleModal";
import AddUsersModal from "../../../User/lists/AddUsersModal";
import { useSelector } from "react-redux";

export default function UsersRoleTable({ }) {

const AppToken = useSelector((state)=>state?.app?.app?.AppToken);

  const [users, setUsers] = useState([]);
 const [usersModal, setUsersModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
 

  useEffect(() => {
    fetchUsersWithRoles();
  }, []);

  const fetchUsersWithRoles = async () => {
    try {
      setLoading(true);

      const userList = await getAppUsersWithRoles(AppToken);;

      const enrichedUsers = await Promise.all(
        userList.map(async (user) => {

          const roles = await getUserRoles(user?.ID, AppToken);

          if (!roles.length) {
            return { ...user, role: null };
          }

          return {
            ...user,
            role: roles[0] // assuming 1 role per scope
          };
        })
      );

      setUsers(enrichedUsers);

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (user) => {

    if (!user.role) return;

    await removeRole({ AppToken,
      userId: user.ID,
      scopeType: user.role.scope_type,
      scopeId: user.role.scope_id
    });

    fetchUsersWithRoles();
  };

  return (
    <div>
         <button
  className="create-btn"
  onClick={() => setUsersModal(true)}
>
  + Add User Role
</button>
         
<table style={{ width: "100%",textAlign:"left", marginTop: 12 }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Scope</th>
            <th>Role</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>

              <td>
                {user.role
                  ? user.role.scope_type === "app"
                    ? "App"
                    : `Batch ${user.role.scope_id}`
                  : "-"}
              </td>

              <td>
                {user.role
                  ? user.role.role_key
                  : "-"}
              </td>

              <td>
                {user.role ? (
                  <>
                    <button
                      onClick={() => setSelectedUser(user)}
                    >
                      Change
                    </button>

                    <button
                      onClick={() => handleRemove(user)}
                      style={{ marginLeft: 6 }}
                    >
                      Remove
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => setSelectedUser(user)}
                  >
                    Assign
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3>User Role Assignments</h3>

      {loading && <p>Loading...</p>}

      
{usersModal&&<AddUsersModal
        
          add={true}
        title={"Select User"}
          onClose={() => { setUsersModal(false)}}
          
          addUser={(user)=>{setSelectedUser(user); setUsersModal(false)}}
        />}
      
      {selectedUser && (
        <AssignRoleModal
         
          user={selectedUser}
          existingRole={selectedUser.role}
          onClose={() => {
            setSelectedUser(null);
            fetchUsersWithRoles();
          }}
        />
      )}

    </div>
  );
}